var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"padding":"0"},attrs:{"id":"favorite"}},[_c('v-container',{staticClass:"px-4 py-12"},[_c('base-section-heading',{attrs:{"title":"Favoris"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }